import { Component, Inject } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
} from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { NgForOf, NgIf } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { QuoteItem } from '../../../overview/overview.data.service';

export function openQuoteConversionDialog(dialog: MatDialog, quote: QuoteItem) {
    const dialogRef = dialog.open(QuoteConversionDialogComponent, {
        autoFocus: false,
        width: '500px',
        data: {
            quote,
        },
    });
    return dialogRef.afterClosed();
}

@Component({
    selector: 'app-quote-conversion-dialog',
    standalone: true,
    imports: [
        FlexModule,
        FormsModule,
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        MatFormField,
        MatLabel,
        TranslateModule,
        MatDialogClose,
        MatOption,
        MatSelect,
        ReactiveFormsModule,
        NgForOf,
        MatInput,
        NgIf,
        MatError,
    ],
    templateUrl: './quote-conversion-dialog.component.html',
    styleUrl: './quote-conversion-dialog.component.scss',
})
export class QuoteConversionDialogComponent {
    public conversionTypes = ['template', 'unit-test'];
    public conversionForm = new FormGroup({
        type: new FormControl('', Validators.required),
        templateDescription: new FormControl('', Validators.required),
        primarySchemes: new FormControl(this.data.quote.primarySchemes, [Validators.required]),
    });

    constructor(@Inject(MAT_DIALOG_DATA) public data) {}

    get dialogResult() {
        const type = this.conversionForm.controls.type.value;
        return {
            id: this.data.quote.id,
            type,
            ...(type !== 'unit-test' && {
                templateDescription: this.conversionForm.controls.templateDescription.value,
                primarySchemes: this.conversionForm.controls.primarySchemes.value,
            }),
        };
    }
}
